import actionTypes from '../webActionTypes';
import GLOBAL from '../../jcolorglobal';

const API_URL = '/EmptyInvoiceAdminAction.do';

function beginAddEmptyInvoice(payload) {
    return { type: actionTypes.beginAddEmptyInvoice, payload };
}

function recvAddEmptyInvoiceError(payload) {
    return { type: actionTypes.recvAddEmptyInvoiceError, payload };
}


function recvAddEmptyInvoiceResult(payload) {
    return { type: actionTypes.recvAddEmptyInvoiceResult, payload };
}


function addEmptyInvoice(payload = {}) {
    return dispatch => {

        dispatch(beginAddEmptyInvoice(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('op', 'addEmptyInvoices');
            formData.append('upldfile', payload.upldfile);
            formData.append('comment', payload.comment);

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                            dispatch(recvAddEmptyInvoiceResult(result));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvAddEmptyInvoiceError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvAddEmptyInvoiceError(error));
                    reject(error);
                });
        });

        return promise;

    };
}


function beginDelEmptyInvoice(payload) {
    return { type: actionTypes.beginDelEmptyInvoice, payload };
}

function recvDelEmptyInvoiceError(payload) {
    return { type: actionTypes.recvDelEmptyInvoiceError, payload };
}


function recvDelEmptyInvoiceResult(payload) {
    return { type: actionTypes.recvDelEmptyInvoiceResult, payload };
}


function delEmptyInvoice(payload = {}) {
    return dispatch => {

        dispatch(beginDelEmptyInvoice(payload)); // dispatch synced action to Del loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('op', 'delEmptyInvoices');
            formData.append('yearmonth', payload.yearmonth);
            formData.append('comment', payload.comment);


            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                            dispatch(recvDelEmptyInvoiceResult(result));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvDelEmptyInvoiceError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvDelEmptyInvoiceError(error));
                    reject(error);
                });
        });

        return promise;

    };
}

function beginGetEmptyInvoiceList(payload) {
    return { type: actionTypes.beginGetEmptyInvoiceList, payload };
}

function recvGetEmptyInvoiceListError(payload) {
    return { type: actionTypes.recvGetEmptyInvoiceListError, payload };
}


function recvGetEmptyInvoiceListResult(payload) {
    return { type: actionTypes.recvGetEmptyInvoiceListResult, payload };
}

function getEmptyInvoiceList(payload = {}) {
    return (dispatch, getState) => {

        dispatch(beginGetEmptyInvoiceList(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            const start = payload.start || 0;
            var querykey = '';
            formData.append('op', 'getEmptyInvoiceList');

            if(payload.yearmonth) {
                formData.append('yearmonth', payload.yearmonth);
                querykey += payload.yearmonth;
            }
            
            formData.append('start', start || 0);
            formData.append('len', getState().emptyInvoice.pageLen || 20);

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                            // 拆解list result成id list and data map兩組資料
                            let ids = {};
                            let data = {};
                            // eslint-disable-next-line
                            result.list.map((listitem, index) => {
                                const id = listitem.istarttag+listitem.invoicenumber;
                                ids[start+index] = id;
                                data[id] = listitem;

                            });
                            const { totalCount } = result;

                            dispatch(recvGetEmptyInvoiceListResult({ids, data, start, totalCount, querykey}));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvGetEmptyInvoiceListError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvGetEmptyInvoiceListError(error));
                    reject(error);
                });
        });

        return promise;

    };
}

function getEmptyInvoiceYearmonthList() {
    return (dispatch, getState) => {

        const promise = new Promise((resolve, reject) => {

            const url = API_URL + '?op=getEmptyInvoiceYearmonthList';

            GLOBAL.fetchWithCookies(url, {
                method: 'GET',
            }).then(response => {
                    
                if (response.status === 503) {
                    // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                    reject({
                        error: 'error.503error',
                        message: '伺服器沒有開啟'
                    });

                    return;
                }

                response.json().then(result => {
                    if (!result) {
                        reject();
                        return;
                    }

                    dispatch(finishGetEmptyInvoiceYearmonthList(result));
                    resolve(result);
                }).catch(error => {
                    reject(error);
                });
            }).catch(error => {
                // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                reject(error);
            });
        });

        return promise;
    };
}

function finishGetEmptyInvoiceYearmonthList(yearmonthList) {

    return { type: actionTypes.finishGetEmptyInvoiceYearmonthList, payload: { yearmonthList: yearmonthList } };
}

const emptyInvoiceActions = {
    beginAddEmptyInvoice,
    recvAddEmptyInvoiceError,
    recvAddEmptyInvoiceResult,
    addEmptyInvoice,
    beginDelEmptyInvoice,
    recvDelEmptyInvoiceError,
    recvDelEmptyInvoiceResult,
    delEmptyInvoice,
    beginGetEmptyInvoiceList,
    recvGetEmptyInvoiceListError,
    recvGetEmptyInvoiceListResult,
    getEmptyInvoiceList,
    getEmptyInvoiceYearmonthList,
};

export default emptyInvoiceActions;


// WEBPACK FOOTER //
// ./src/actions/creators/emptyInvoiceActions.js